import React, { useState } from "react"
import Assignation from "../../../models/Assignation"
import EditButtonDialog from "../Utils/Dialogs/EditButtonDialog"
import { TextField } from "@material-ui/core"
import { updateAssignation } from "../../../actions/assignation/assignationUpdate"
import { useDispatch } from "react-redux"

interface AssignationCreaLinkEditProps {
    assignation: Assignation
}

const AssignationCreaLinkEdit: React.FC<AssignationCreaLinkEditProps> = ({ assignation }) => {
    const dispatch = useDispatch()
    const [creaLink, setNewCreaLink] = useState<string | null>(null)

    const handleAccept = () => {
        dispatch(updateAssignation({ ...assignation, creaLink }, 'Asignación actualizada'))
    }

    return (
        <EditButtonDialog
            title="Editar link aula CREA"
            onAccept={handleAccept}>
            <TextField
                style={{ width: '100%' }}
                label="Link aula CREA"
                onChange={e => setNewCreaLink(e.target.value)}
            />
        </EditButtonDialog>

    )

}



export default AssignationCreaLinkEdit